import { Divider, FieldTypes, RepeatableSection } from '@msaf/core-react'
import { AquiferTestFieldsEdit, AquiferTestObservationWellFieldsEdit } from '../../../../types/form-types'
import { ValidationErrors } from '../../../hooks/use-edit-form'
import AquiferTestDetailsEditForm from './aquifer-test-details-edit'
import AquiferTestObservationWellsEditForm from './aquifer-test-observation-wells-edit'
import AquiferTestResultsEditForm from './aquifer-test-results-edit'
import AquiferTestQualityRatingFormEdit from './quality-rating-edit'
import TestAnalysisEditForm from './test-analysis-edit'

export interface AquiferEditFormInterface {
  fields: Partial<AquiferTestFieldsEdit>
  isLoading: boolean
  wellId: string
  setValue: (fieldId: keyof AquiferTestFieldsEdit, value: FieldTypes, key?: string, index?: number) => void
  removeField: (fieldId: keyof AquiferTestFieldsEdit, index: number) => void
  addField: (fieldId: keyof AquiferTestFieldsEdit, initFields: {}) => void
  validationErrors?: ValidationErrors<AquiferTestFieldsEdit>
}

export default function AquiferTestEditForm({
  fields,
  isLoading,
  setValue,
  wellId,
  addField,
  removeField,
  validationErrors = {},
}: AquiferEditFormInterface) {
  return (
    <>
      <AquiferTestDetailsEditForm
        fields={fields}
        isLoading={isLoading}
        setValue={setValue}
        validationErrors={validationErrors}
      />
      <Divider />
      <TestAnalysisEditForm fields={fields} isLoading={isLoading} setValue={setValue} wellId={wellId} />
      <Divider />
      <AquiferTestQualityRatingFormEdit fields={fields} isLoading={isLoading} setValue={setValue} />
      <Divider />
      <AquiferTestResultsEditForm
        fields={fields}
        isLoading={isLoading}
        setValue={setValue}
        validationErrors={validationErrors}
      />
      <Divider />
      <RepeatableSection
        heading='Observation wells'
        sectionName='Observation well'
        removeField={(index: number) => removeField('aquiferTestObservationWells', index)}
        addField={() => addField('aquiferTestObservationWells', {})}
        allowEmpty={true}
        isSkeleton={isLoading}
      >
        {fields.aquiferTestObservationWells?.map((obsWell: Partial<AquiferTestObservationWellFieldsEdit>, index) => (
          <AquiferTestObservationWellsEditForm
            key={obsWell.id}
            fields={obsWell}
            wellId={wellId}
            isLoading={isLoading}
            index={index}
            setValue={(key: keyof AquiferTestObservationWellFieldsEdit, value: FieldTypes) =>
              setValue('aquiferTestObservationWells', value, key, index)
            }
            validationErrors={validationErrors?.aquiferTestObservationWells?.[index] as ValidationErrors}
          />
        ))}
      </RepeatableSection>
    </>
  )
}
